function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import amplitude from 'amplitude-js';
import { ampli as ampliSdkWithNoEvents } from './__generated__/ampli';
export var getAllAmpliProps = function getAllAmpliProps(obj) {
  return Array.from(new Set([].concat(_toConsumableArray(Object.keys(obj)), _toConsumableArray(Object.getOwnPropertyNames(Object.getPrototypeOf(obj))))));
};
var ampliSdkWithNoEventProps = getAllAmpliProps(ampliSdkWithNoEvents);
export var DEFAULT_AMPLI_INSTANCE_NAME = 'care-ampli-instance';
export var CareAmpli = function () {
  function CareAmpli() {
    var _this = this;

    _classCallCheck(this, CareAmpli);

    _defineProperty(this, "initializeAmplitude", function () {
      var _this$config = _this.config,
          analyticsEnabled = _this$config.analyticsEnabled,
          isProd = _this$config.isProd,
          instanceName = _this$config.instanceName,
          ampliModule = _this$config.ampliModule;
      var ampli = ampliModule.ampli,
          ApiKey = ampliModule.ApiKey,
          DefaultOptions = ampliModule.DefaultOptions;

      if (analyticsEnabled && (!ApiKey || isProd && !ApiKey.production || !isProd && !ApiKey.development)) {
        throw new Error('CareAmpli: Missing Analytics key');
      }

      var apiKey = ApiKey[isProd ? 'production' : 'development'];
      var amplitudeInstance = amplitude.getInstance(instanceName || DEFAULT_AMPLI_INSTANCE_NAME);
      amplitudeInstance.init(apiKey, undefined, DefaultOptions);
      ampli.load({
        disabled: !analyticsEnabled,
        client: {
          instance: amplitudeInstance
        }
      });
    });

    _defineProperty(this, "createModifiedAmpliSdk", function () {
      return getAllAmpliProps(_this.unmodifiedAmpli).reduce(function (acc, ampliProp) {
        var ampliValue = _this.unmodifiedAmpli[ampliProp];

        if (typeof ampliValue !== 'function') {
          var ampliHelperThis = _this;
          Object.defineProperty(acc, ampliProp, {
            get: function get() {
              return ampliHelperThis.unmodifiedAmpli[ampliProp];
            }
          });
          return acc;
        }

        if (ampliSdkWithNoEventProps.includes(ampliProp) || ampliValue.length !== 3) {
          acc[ampliProp] = ampliValue;
          return acc;
        }

        acc[ampliProp] = function (eventProps, options, extra) {
          return _this.withCommonData(ampliValue, eventProps, options, extra);
        };

        return acc;
      }, {});
    });

    _defineProperty(this, "withCommonData", function (method, eventPropsWithoutCommonData, options, extra) {
      var eventProps = eventPropsWithoutCommonData ? _objectSpread(_objectSpread({}, _this.getCommonData()), eventPropsWithoutCommonData) : _this.getCommonData();
      return method.call(_this.unmodifiedAmpli, eventProps, options, extra);
    });
  }

  _createClass(CareAmpli, [{
    key: "getCommonData",
    get: function get() {
      return this.config.commonDataFn;
    }
  }, {
    key: "unmodified",
    get: function get() {
      var careAmpliThis = this;
      return {
        get ampli() {
          return careAmpliThis.unmodifiedAmpli;
        }

      };
    }
  }, {
    key: "ampli",
    get: function get() {
      return this.modifiedAmpli;
    }
  }, {
    key: "initialize",
    value: function initialize(config) {
      if (!config) throw new Error('CareAmpli: Missing config');
      this.config = config;
      this.unmodifiedAmpli = config.ampliModule.ampli;
      this.initializeAmplitude();
      this.modifiedAmpli = this.getCommonData ? this.createModifiedAmpliSdk() : this.unmodifiedAmpli;
    }
  }]);

  return CareAmpli;
}();
//# sourceMappingURL=ampli-variant.js.map